var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66797 28.834C6.66797 26.0725 8.90655 23.834 11.668 23.834H45.0013C47.7628 23.834 50.0013 26.0725 50.0013 28.834V32.1673H59.5313C60.7883 32.1673 61.9991 32.6407 62.9228 33.4933L71.726 41.6195C72.7515 42.566 73.3346 43.898 73.3346 45.2935V58.834H63.3346V55.5007H70.0013V45.2935C70.0013 44.8283 69.807 44.3843 69.4651 44.0688L60.6618 35.9426C60.354 35.6585 59.9503 35.5007 59.5313 35.5007H50.0013V55.5007H53.3346V58.834H25.0013V55.5007H46.668V28.834C46.668 27.9135 45.9218 27.1673 45.0013 27.1673H11.668C10.7475 27.1673 10.0013 27.9135 10.0013 28.834V55.5007H15.0013V58.834H6.66797V28.834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9987 60.5C21.8397 60.5 23.332 59.0077 23.332 57.1667C23.332 55.3257 21.8397 53.8333 19.9987 53.8333C18.1577 53.8333 16.6654 55.3257 16.6654 57.1667C16.6654 59.0077 18.1577 60.5 19.9987 60.5ZM19.9987 63.8333C23.6805 63.8333 26.6654 60.8485 26.6654 57.1667C26.6654 53.4848 23.6805 50.5 19.9987 50.5C16.3168 50.5 13.332 53.4848 13.332 57.1667C13.332 60.8485 16.3168 63.8333 19.9987 63.8333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3346 60.5C60.1756 60.5 61.668 59.0077 61.668 57.1667C61.668 55.3257 60.1756 53.8333 58.3346 53.8333C56.4936 53.8333 55.0013 55.3257 55.0013 57.1667C55.0013 59.0077 56.4936 60.5 58.3346 60.5ZM58.3346 63.8333C62.0165 63.8333 65.0013 60.8485 65.0013 57.1667C65.0013 53.4848 62.0165 50.5 58.3346 50.5C54.6528 50.5 51.668 53.4848 51.668 57.1667C51.668 60.8485 54.6528 63.8333 58.3346 63.8333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6654 47.1673H48.332V43.834H71.6654V47.1673Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.668 45.4993V32.166H30.0013V45.4993H26.668Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9987 27.166C55.9192 27.166 56.6654 27.9122 56.6654 28.8327V33.8327H53.332V28.8327C53.332 27.9122 54.0782 27.166 54.9987 27.166Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0013 40.4993H21.668V37.166H35.0013V40.4993Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3346 33.8333H51.668V30.5H58.3346V33.8333Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9987 22.9993C54.0782 22.9993 53.332 22.2532 53.332 21.3327V18.8327C53.332 17.9122 54.0782 17.166 54.9987 17.166C55.9192 17.166 56.6654 17.9122 56.6654 18.8327V21.3327C56.6654 22.2532 55.9192 22.9993 54.9987 22.9993Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.832 28.8327C60.832 27.9122 61.5782 27.166 62.4987 27.166H64.9987C65.9192 27.166 66.6654 27.9122 66.6654 28.8327C66.6654 29.7532 65.9192 30.4993 64.9987 30.4993H62.4987C61.5782 30.4993 60.832 29.7532 60.832 28.8327Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5996 24.1197C58.9815 23.4375 59.0335 22.3835 59.7155 21.7655L61.2391 20.3849C61.9213 19.7667 62.9753 19.8185 63.5933 20.5007C64.2115 21.1827 64.1595 22.2367 63.4775 22.8549L61.9538 24.2355C61.2716 24.8537 60.2176 24.8017 59.5996 24.1197Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.8576e0cf84911a61ed72ab14a4fbe080.svg";
export { ForwardRef as ReactComponent };